<template>
  <Modal position="end" ref="modalRef">
    <template #header>Included utilities</template>
    <template #body>
      <IncludedUtilitiesForm ref="formRef" />
    </template>
    <template #footer>
      <Button variant="ghost" @click="modalRef?.close">Cancel</Button>
      <Button @click="save" :loading="formRef?.form.submitting">Save</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, Modal } from '@tallo/design-system';
import { IncludedUtilitiesForm } from '@tallo/investor/property';

const modalRef = ref<InstanceType<typeof Modal>>();
const formRef = ref<InstanceType<typeof IncludedUtilitiesForm>>();

async function save() {
  await formRef.value?.save();

  modalRef.value?.close();
}

defineExpose({ modalRef });
</script>
